import {
    GRIEVANCE_REQUEST_CREATE,
    GRIEVANCE_REQUEST_CREATE_FAIL,
    GRIEVANCE_REQUEST_CREATE_SUCCESS,
    DELETE_GRIEVANCE_REQUEST,
    DELETE_GRIEVANCE_REQUEST_FAIL,
    DELETE_GRIEVANCE_REQUEST_SUCCESS,
    GET_GRIEVANCE_REQUEST_DETAILS,
    GET_GRIEVANCE_REQUEST_DETAILS_FAIL,
    GET_GRIEVANCE_REQUEST_DETAILS_SUCCESS,
    RESET,
    RESET_GRIEVANCE_REQUEST_CREATE,
    RESET_GRIEVANCE_REQUEST_DELETE,
    RESET_GRIEVANCE_REQUEST_DETAILS,
    UPDATE_GRIEVANCE_REQUEST,
    UPDATE_GRIEVANCE_REQUEST_FAIL,
    UPDATE_GRIEVANCE_REQUEST_SUCCESS,
} from "./actionsTypes";

const initialState = {
    grievanceRequestList: [],
    grievanceRequestDetails: [],
    createResult: {},
    loading: false,
    detailsLoading: false,
    loadingCreate: false,
    deleteResult: {},
    error: {
        message: "",
    },
};

const GrievanceRequestReducer = (state = initialState, action) => {
    if (!action) return state;

    switch (action.type) {
        case GRIEVANCE_REQUEST_CREATE:
            state = { ...state, createResult: {}, loadingCreate: true };
            break;
        case GRIEVANCE_REQUEST_CREATE_SUCCESS:
            state = { ...state, createResult: action.payload, loadingCreate: false };
            break;
        case GRIEVANCE_REQUEST_CREATE_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                createResult: {},
                loadingCreate: false,
            };
            break;

        case GET_GRIEVANCE_REQUEST_DETAILS:
            state = { ...state, detailsLoading: true, grievanceRequestDetails: {} };
            break;
        case GET_GRIEVANCE_REQUEST_DETAILS_SUCCESS:
            state = { ...state, grievanceRequestDetails: action.payload, detailsLoading: false };
            break;
        case GET_GRIEVANCE_REQUEST_DETAILS_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                detailsLoading: false,
            };
            break;

        case UPDATE_GRIEVANCE_REQUEST:
            state = { ...state, createResult: {}, loading: true };
            break;
        case UPDATE_GRIEVANCE_REQUEST_SUCCESS:
            state = { ...state, createResult: action.payload, loading: false };
            break;
        case UPDATE_GRIEVANCE_REQUEST_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
            };
            break;

        case DELETE_GRIEVANCE_REQUEST:
            state = { ...state, deleteResult: {}, loading: true, };
            break;
        case DELETE_GRIEVANCE_REQUEST_SUCCESS:
            state = { ...state, deleteResult: action.payload, loading: false };
            break;
        case DELETE_GRIEVANCE_REQUEST_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
                deleteResult: {}
            };
            break;
        case RESET_GRIEVANCE_REQUEST_DETAILS:
            state = { ...state, grievanceRequestDetails: {}, detailsLoading: false };
            break;

        case RESET:
            state = { ...state, grievanceRequestList: [], createResult: {} };
            break;
        case RESET_GRIEVANCE_REQUEST_CREATE:
            state = { ...state, createResult: {} };
            break;
        case RESET_GRIEVANCE_REQUEST_DELETE:
            state = { ...state, deleteResult: {} };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default GrievanceRequestReducer;